import React from 'react'

import 'aframe'
import 'aframe-particle-system-component'
import 'aframe-mouse-cursor-component'
import { Entity, Scene } from 'aframe-react'

class ThreeScene extends React.Component {
  constructor(props){
      super(props);
      this.state = {
          isTouchScreen: false,
          zoom: 80,
          zoomValue: 0,
          isCollapsed: false,
          currentImage: "",
          currentSelectedtourIndex: 0,
          rerender: false
      }
  }
  render() {
    return (
      <Scene cursor="rayOrigin: mouse, fuse: false" raycaster="objects: .raycastable">
        <a-assets>
          <a-mixin id="picture" geometry="primitive: box" material="side: double; color: white"></a-mixin>
          <img id="thumb1" crossorigin src={this.props.selectedFile} alt="" />
        </a-assets>
        <Entity ref={this.camera}>
          {
            !this.state.isTouchScreen ?
              <a-camera
                id="camera"
                fov={this.state.zoom}
                wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"
                look-controls="reverseMouseDrag: true, reverseTouchDrag: true"
                aframe-injected=""
                data-aframe-inspector-original-camera=""
                vr-mode-ui="enabled: false"
              /> :
              <a-camera
                id="camera"
                fov={this.state.zoom}
                wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"
                tocuh-look-controls="reverseMouseDrag: true, reverseTouchDrag: true"
                aframe-injected=""
                data-aframe-inspector-original-camera=""
                vr-mode-ui="enabled: false"
              />
          }
        </Entity>
        <Entity primitive="a-sky" src={this.props.selectedFile} segments-height={100} segments-width={200} radius={200} crossorigin />
      </Scene>
    )
  }
}

export default ThreeScene